import api from 'Application/api/api';

const changeTemplateState = (signal, values) =>
	api.put('/template-state', values, {
		signal,
	});

export default changeTemplateState;
